<script setup>
import { ref } from "vue";
import { useSeoStore } from "@stores/seo";

const props = defineProps({
  game: {
    type: Object,
    required: true,
  },
});

const seoStore = useSeoStore();

const showDescription = ref(false);

</script>

<template>
  <div
    v-show="seoStore.seo?.html"
    @click="showDescription = !showDescription"
    class="mb-16 px-3 sm:px-10 transition-all duration-500 ease-in rounded-md relative overflow-hidden border border-separator"
    :class="showDescription ? ' md:py-10' : 'py-0 max-h-20 md:max-h-64'"
  >
    <div
      class="flex items-center transition-all w-full border-separator duration-500"
      :class="showDescription ? 'py-2 border-b-2' : 'py-4 border-b-0'"
    >
      <div
        class="flex items-center justify-center overflow-hidden bg-cover bg-center rounded-md transition-all duration-500"
        :style="{
          backgroundImage: `url('${
            game?.game?.custom_image ?? game?.game?.image
          }')`,
        }"
        :class="showDescription ? 'h-0 w-0' : 'h-12 w-9'"
      ></div>

      <div
        class="relative px-0 transition-all w-fit text-lg font-extrabold uppercase after:w-full after:h-0 after:bg-bzRed after:absolute after:-bottom-[3px] after:rounded-md after:left-0"
        :class="showDescription ? 'px-0' : 'px-5'"
      >
        {{ game?.game?.name }}
        <p class="text-xs text-white/50">Descrição do Jogo</p>
      </div>

      <div
        class="ml-auto text-bzRed transition-all font-semibold"
        :class="showDescription ? 'rotate-180' : ' rotate-0'"
      >
        <svg class="h-5 transition-all" fill="currentColor" viewBox="0 0 16 16">
          <path
            fill-rule="evenodd"
            d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
          />
        </svg>
      </div>
    </div>

    <div
      class="flex pt-5 transition-all duration-100"
      :class="showDescription ? 'gap-5' : 'gap-0'"
    >
      <div class="hidden sm:block float-right">
        <div
          class="flex items-center justify-center overflow-hidden bg-cover bg-center rounded-md transition-all duration-500"
          :class="showDescription ? 'h-72 w-56' : 'h-0 w-0'"
        >
          <img :src="game?.game?.custom_image ?? game?.game?.image" alt="" />
        </div>
      </div>

      <div
        class="transition-all"
        :class="showDescription ? 'sm:w-3/4 sm:ml-4' : 'w-full ml-0'"
      >
        <div class="flex items-center gap-2 pb-4">
          <div
            v-for="category in game?.game?.categories"
            class="text-sm font-bold py-0.5 px-3 bg-bzRed/55 text-white/60 rounded uppercase"
          >
            {{ category.name }}
          </div>
        </div>

        <article
          class="text-sm font-medium transition-all duration-500 overflow-hidden"
          v-html="seoStore.seo?.html"
        ></article>
      </div>
    </div>

    <div
      class="hidden md:block w-full transition-all duration-500 absolute bottom-0 left-0 bg-gradient-to-b from-transparent via-primary/90 to-primary"
      :class="showDescription ? 'h-0' : 'h-36'"
    ></div>
  </div>
</template>
